import React from 'react'
import { useTranslation } from 'react-i18next'

import { getDocUploadFailMessage } from '@pages/Profile/DocumentManagementUpload/documentManagementUploadStatuses'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

interface Props {
  description: string
  message?: string
  title?: string
}

export const AlreadyUploadedModal: BaseModalType<Props> = (props) => {
  const { t } = useTranslation()
  const { close } = props
  const { title = t('Upload failed') } = props
  const { message } = props
  const {
    description = message
      ? t(getDocUploadFailMessage(message))
      : t('The document has been already uploaded'),
  } = props

  return (
    <Modal>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>{description}</Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Got It')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
